import { colors } from 'globalStyle';
import { projectStateType } from 'types';

export const STATUS_OPEN_PROJECTS = Object.freeze([
  projectStateType.OPEN,
]);

export const STATUS_COMING_SOON_PROJECTS = Object.freeze([
  projectStateType.ADVERTISING_CAMPAIGN,
]);

export const STATUS_FINANCED_PROJECTS = Object.freeze([
  projectStateType.PENDING_PAYMENT,
  projectStateType.MONEY_GIVE,
  projectStateType.PRE_MONEY_GIVE,
  projectStateType.PENDING_BOND,
  projectStateType.PENDING_COMMISSION,
  projectStateType.ARREARS,
  projectStateType.OPEN,
]);

export const STATUS_CLOSED_PROJECTS = Object.freeze([
  projectStateType.CLOSED,
]);

export const filterOpenProjects = (projects) => projects?.filter(
  (project) => project.status === projectStateType.OPEN
    && project.maxAmount !== project.currentAmount,
);

export const filterComingSoonProjects = (projects) => projects?.filter(
  (project) => project.status === projectStateType.ADVERTISING_CAMPAIGN,
);

export const filterClosedProjects = (projects) => projects?.filter(
  (project) => project.status === projectStateType.CLOSED,
);

export const filterFinancedProjects = (projects) => projects?.filter(
  (project) => project.status === projectStateType.PENDING_PAYMENT
    || project.status === projectStateType.MONEY_GIVE
    || project.status === projectStateType.PRE_MONEY_GIVE
    || project.status === projectStateType.PENDING_BOND
    || project.status === projectStateType.PENDING_COMMISSION
    || project.status === projectStateType.ARREARS
    || (project.status === projectStateType.OPEN
      && project.maxAmount === project.currentAmount),
);

export const PROJECT_STATUS_INFO = Object.freeze({
  OPEN: {
    text: 'Disponible',
    color: colors.success,
    filter: filterOpenProjects,
    status: STATUS_OPEN_PROJECTS,
    fullText: 'Proyectos disponibles',
  },
  COMING_SOON: {
    text: 'Pre-lanzamiento',
    color: colors.error,
    filter: filterComingSoonProjects,
    status: STATUS_COMING_SOON_PROJECTS,
    fullText: 'Proyectos en pre-lanzamiento',
  },
  FINANCED: {
    text: 'Financiados',
    color: colors.secondary,
    filter: filterFinancedProjects,
    status: STATUS_FINANCED_PROJECTS,
    fullText: 'Proyectos financiados',
  },
  CLOSED: {
    text: 'Cerrados',
    color: colors.GRAY_3,
    filter: filterClosedProjects,
    status: STATUS_CLOSED_PROJECTS,
    fullText: 'Proyectos cerrados',
  },
});

const getSortValue = (project) => {
  if (STATUS_OPEN_PROJECTS.find((status) => project?.status === status)) {
    return 1;
  }
  if (STATUS_COMING_SOON_PROJECTS.find((status) => project?.status === status)) {
    return 2;
  }
  if (STATUS_FINANCED_PROJECTS.find((status) => project?.status === status)) {
    return 3;
  }
  return 4;
};

export function sortProjects(projects = []) {
  return projects.sort((a, b) => getSortValue(a) - getSortValue(b));
}

export function projectIsCollecting(status, currentAmount, minAmount, maxAmount, endDate) {
  return status === 'OPEN' && (
    maxAmount === currentAmount || (new Date(endDate) < new Date() && minAmount <= currentAmount)
  );
}
